module.exports = __webpack_public_path__ + "img/icn_mic.fc0f6e57.svg";